<template>
  <div>
    <HttpContentView :endpoint="indexEndpoint" @response="settings = $event" v-model:reload="reload">
      <template v-slot:content>
        <div class="d-flex flex-column g-4">
          <SettingsSegment v-for="item in categories" :key="item.title" :community-id="communityId" :module="module" :settings="item.items" @reload="reload = true"/>
        </div>
      </template>
    </HttpContentView>
  </div>
</template>

<script>
import SettingsSegment from "@/systems/modules/settings/SettingsSegment.vue";
import {HttpContentView, utilities} from "@niftybit/vue";
import localization from "@/localization";

export default {
  name: "SettingsView",
  components: {HttpContentView, SettingsSegment},
  props: {
    communityId: String,
    module: String
  },
  data() {
    return {
      settings: [],
      editing: undefined,
      reload: false
    }
  },
  computed: {
    categories() {
      let list = [...new Set(this.settings.map(item => item.category))];
      return list.map(category => {
        return {
          title: localization.translate(category),
          items: this.settings.filter(item => item.category === category)
        }
      });
    },
    indexEndpoint() {
      return utilities.path('communities/@/modules/@/settings', this.communityId, this.module);
    }
  }
}
</script>

<style scoped>

</style>
